import axios from "axios";
import {
  GET_SATISFACTION,
  GET_SATISFACTION_ERROR,
  SATISFACTION_LOADING,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

//  Get kiosk satisfaction points per printer
export const getSatisfaction = ({ startDate, endDate }) => async (dispatch) => {
  try {
    dispatch({ type: SATISFACTION_LOADING });
    const res = await axios.get("/api/monitoring/satisfaction", {
      params: { startDate, endDate },
    });
    dispatch({
      type: GET_SATISFACTION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({ type: GET_SATISFACTION_ERROR });
    // No response: the network or the server is down
    if (!err.response) {
      toastr.error("Server unreachable");
      return;
    }
    if (
      err.response.status === 401 &&
      err.response.data.msg === "Token is not valid"
    ) {
      window.localStorage.clear("x-auth-token");
      toastr.error("Session expired");
      dispatch(logout());
    }
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => toastr.error(error.msg));
    }
  }
};
